<template>
  <div>
    <v-card class="py-2" tile flat>
      <v-layout py-12 wrap>
        <v-flex align-self-center text-center xs12>
          <span
            style="
              padding-left: 50px;
              font-family: poppinsbold;
              color: #e7ab5f;
              font-size: 38px;
              letter-spacing: 4px;
            "
          >
            VISION, MISSION AND VALUES
          </span>
        </v-flex>
      </v-layout>

      <v-layout wrap>
        <v-flex v-for="(item, i) in items" :key="i" xs12 lg12>
        
          <span v-if="i % 2 != 0">
            <v-layout wrap>
              <v-flex xs12 lg6>
                <v-img contain width="100%" height="500px" v-if="item.image" :src="baseURL + item.image">
                   <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="#FF2323"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                </v-img>
              </v-flex>
              <v-flex xs1> </v-flex>
              <v-flex xs12 lg5>
                <v-layout pt-12 wrap>
                  <v-flex xs12 lg12>
                    <v-layout justify-center wrap>
                      <v-flex xs12 lg12>
                        <span
                          style="
                            font-family: poppinsbold;
                            font-size: 24px;
                            color: #00000;
                            letter-spacing: 1px;
                          "
                        >
                          {{ item.heading }}
                        </span>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap>
                      <v-flex xs12 lg12>
                        <span
                          style="
                            font-family: poppinsregular;
                            font-size: 17px;
                            color: #00000;
                            letter-spacing: 1px;
                          "
                        >
                          {{ item.text }}
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </span>
          <span v-else>
            <v-layout wrap>
              <v-flex xs12 lg1> </v-flex>
              <v-flex xs12 lg5>
                <v-layout pt-12 wrap>
                  <v-flex xs12 lg12>
                    <v-layout justify-center wrap>
                      <v-flex xs12 lg12>
                        <span
                          style="
                            font-family: poppinsbold;
                            font-size: 24px;
                            color: #00000;
                            letter-spacing: 1px;
                          "
                        >
                          {{ item.heading }}
                        </span>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap>
                      <v-flex xs12 lg12>
                        <span
                          style="
                            font-family: poppinsregular;
                            font-size: 17px;
                            color: #00000;
                            letter-spacing: 1px;
                          "
                        >
                          {{ item.text }}
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 lg6>
                <v-img contain width="100%" height="500px" v-if="item.image" :src="baseURL + item.image">
                   <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="#FF2323"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                </v-img>
              </v-flex>
            </v-layout>
          </span>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return { about: [], items: [] };
  },
  mounted: function () {
    this.getAbout();
  },
  methods: {
    getAbout() {
      // this.appLoading = true;
      axios({
        method: "GET",
        url: "/aboutus/view",
      })
        .then((response) => {
          if (response.data.status) {
            this.about = response.data.data;
            console.log('abt',this.about.vision)
             this.items.push(this.about.vision)
            this.items.push(this.about.mission);
            this.items.push(this.about.values);
          }
        })
        .catch(() => {
          // this.appLoading = false;
        });
    },
  },
};
</script>